import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ModalSuccessRegisterCLABE, RegisterCLABEAdvice } from './successRegisterCLABE.styles';

export default function SuccessRegisterCLABE(props) {
  const [successRegisterCLABE, setSuccessRegisterCLABE] = useState(
    props.showModalSuccessRegisterCLABE
  );
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    setSuccessRegisterCLABE(props.showModalSuccessRegisterCLABE);
  }, [props.showModalSuccessRegisterCLABE]);

  const closeModal = () => setSuccessRegisterCLABE(false);

  return (
    <ModalSuccessRegisterCLABE showModalSuccessRegisterCLABE={successRegisterCLABE}>
      <div>
        <div>
          <h3>Dar de alta una nueva CLABE</h3>
          <figure onClick={closeModal}>
            <img
              src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_modal_close.png`}
              alt="icono para cerrar la ventana"
            />
          </figure>
        </div>
        <RegisterCLABEAdvice>
          <div>
            <figure>
              <img
                src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_modal_success.png`}
                alt=""
              />
            </figure>
            <p>Tu CLABE fue dada de alta con éxito.</p>
          </div>
          <Link to="/inversionista/dashboard/cuenta-clabe">Cerrar</Link>
        </RegisterCLABEAdvice>
      </div>
    </ModalSuccessRegisterCLABE>
  );
}
